module.exports = __webpack_public_path__ + "static/media/History_Screen.a2b65f70.png";